
import React from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { ManualTabContent } from "./ManualTabContent";
import { AITabContent } from "./AITabContent";
import { SermonFormData } from "@/hooks/sermon-plans/types";

interface WelcomeDialogTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  setFormData: (data: SermonFormData) => void;
}

export function WelcomeDialogTabs({ activeTab, onTabChange, setFormData }: WelcomeDialogTabsProps) {
  return (
    <div className="py-4">
      <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="manual">Create Manually</TabsTrigger>
          <TabsTrigger value="ai">AI Assisted</TabsTrigger>
        </TabsList>
        
        <TabsContent value="manual" className="mt-4 pb-4 space-y-4">
          <ManualTabContent setFormData={setFormData} />
        </TabsContent>
        
        <TabsContent value="ai" className="mt-4 pb-4">
          <AITabContent />
        </TabsContent>
      </Tabs>
    </div>
  );
}
